<template>
    <yd-layout>
        <navBar title="首页" :back="false"></navBar>

        <!-- 轮播图 -->
        <yd-slider autoplay="5000">
            <yd-slider-item v-for="item,index in ads" :key="'ad_'+index">
                <a href="http://www.ydcss.com">
                    <img :src="item.image">
                </a>
            </yd-slider-item>
        </yd-slider>

        <!-- 通知 -->
        <div style="display: flex; padding:8px 8px; align-items: center; background-color: white">
            <yd-icon name="clock" size="0.4rem" style="margin-right: 8px"></yd-icon>
            <yd-rollnotice autoplay="2000">
                <yd-rollnotice-item>清明节放假通知</yd-rollnotice-item>
                <yd-rollnotice-item>清明节加班通知</yd-rollnotice-item>
                <yd-rollnotice-item>清明节调休通知</yd-rollnotice-item>
            </yd-rollnotice>
        </div>

        <!-- 快捷菜单 -->
        <yd-grids-group rows="4">
            <yd-grids-item v-for="menu,index in menus" :key="'home_menu'+index">
                <yd-icon slot="icon" name="home" :color="$config('theme')"></yd-icon>
                <span slot="text">{{menu.title}}</span>
            </yd-grids-item>
        </yd-grids-group>
    </yd-layout>
</template>

<script>
    export default {
        name: 'Home',
        components: {},
        props: [],
        data: function () {
            return {
                ads: [
                    {image: 'http://static.ydcss.com/uploads/ydui/1.jpg'},
                    {image: 'http://static.ydcss.com/uploads/ydui/2.jpg'},
                    {image: 'http://static.ydcss.com/uploads/ydui/3.jpg'}
                ],
                menus: [
                    {title: '日志'},
                    {title: '周报'},
                    {title: '请假'},
                    {title: '申请'},
                    {title: '日志'},
                    {title: '周报'},
                    {title: '请假'},

                ],
            }
        },
        computed: {
            // userInfo: ({user}) => user.userInfo,
        },
        created: function () {

        },
        methods: {
            popRoute: function () {
                this.$pop();
            }
        }
    }
</script>

<style scoped>
    .yd-grids-4:before {
        border-bottom: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/home.vue